import React, { useState } from "react";
import Select from "react-select";
import { updateCustomerBulk } from "../../api/customers";

const REPORT_STATUS_OPTIONS = [
  { value: "done", label: "Done", color: "#38A169" }, // Green
  { value: "wip", label: "WIP", color: "#3182CE" }, // Blue
  { value: "uncategorized", label: "Uncatz", color: "#DD6B20" }, // Orange
  { value: "issue", label: "Issue", color: "#E53E3E" }, // Red
];

const customStyles = {
  control: (styles) => ({
    ...styles,
    minWidth: 160,
    fontSize: 14,
    zIndex: 1000,
  }),
  menu: (styles) => ({
    ...styles,
    zIndex: 1000,
  }),
  option: (styles, { data, isFocused, isSelected }) => ({
    ...styles,
    backgroundColor: isSelected ? data.color : isFocused ? "#EDF2F7" : "white",
    color: isSelected ? "white" : "black",
    cursor: "pointer",
  }),
  singleValue: (styles, { data }) => ({
    ...styles,
    color: data.color,
    fontWeight: "bold",
  }),
};

const BulkReportStatusSelect = ({
  selectedIds = [],
  customerList,
  setCustomerList,
}) => {
  const [selectedOption, setSelectedOption] = useState(null);

  const handleChange = async (option) => {
    if (!option || !selectedIds.length) return;

    setSelectedOption(option);

    try {
      await updateCustomerBulk({
        ids: selectedIds,
        report_status: option.value,
      });

      const updated = customerList.map((cust) =>
        selectedIds.includes(cust.id)
          ? { ...cust, report_status: option.value }
          : cust
      );

      setCustomerList(updated);
    } catch (err) {
      console.error("Bulk report status update failed", err);
    }
  };

  return (
    <Select
      placeholder="Set Status"
      value={selectedOption}
      options={REPORT_STATUS_OPTIONS}
      onChange={handleChange}
      styles={customStyles}
      isSearchable={false}
      menuPlacement="auto"
    />
  );
};

export default BulkReportStatusSelect;
